const { m } = require('minthril');

function ContactPage() {
  let submitted = false;

  return {
    view: () => m('section.contact-page',
      m('div.contact-page__intro',
        m('p.products__eyebrow', 'Get in touch'),
        m('h1', 'Contact'),
        m('p', 'Questions about a part, a project, or a mid-engine problem that needs solving? Send us a note.')
      ),
      submitted
        ? m('p.contact-page__success', 'Thanks — your message has been sent.')
        : m('form.contact-page__form', {
          action: 'https://bullshift-performance.myshopify.com/contact',
          method: 'post',
          onsubmit: () => { submitted = true; }
        },
        m('label', m('span', 'Name'), m('input', { name: 'contact[name]', required: true })),
        m('label', m('span', 'Email'), m('input', { type: 'email', name: 'contact[email]', required: true })),
        m('label', m('span', 'Phone'), m('input', { type: 'tel', name: 'contact[phone]' })),
        m('label.contact-page__message', m('span', 'Message'), m('textarea', { name: 'contact[body]', rows: 7, required: true })),
        m('button.button', { type: 'submit' }, 'Submit')
      )
    )
  };
}

module.exports = { ContactPage };
